export enum EResponseStatus {
  PROMO_INVALID_CODE = 100,
  PROMO_USED_CODE = 101,
  PROMO_SYSTEM_ERROR = 102,
  SUCCESS = 200,
  ACCEPTED = 202,
  BAD_REQUEST = 400,
  LATE_PAYMENT = 402,
  BLACK_LIST = 403,
  NO_CLARO_NUMBER = 406,
  INVALID_MSISDN = 412,
  AUTH_RULES = 422,
  MAX_DAY_ATTEMPTS = 423,
  MAX_ATTEMPTS = 429,
  INTERNAL_ERROR = 500,
  BL_TEMPORAL = 623, // TODO
  BL_PERMANENT = 624, // TODO
  DEFAULT_ERROR = 650
}
